<template v-if="userData ==true">
  <v-container fluid>
    <v-app-bar
      :collapse="collapseStatus"
      :clipped-left="true"
      v-bind:style="{'background-color': (Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color : '')}"
      app
      dark
    >
      <v-app-bar-nav-icon @click.stop="status" />
      <v-toolbar-title class="ml-0 pl-4">
        <span class="hidden-xs-and-down">
          <img style="height:22px" class="mt-1" :src="companylogo" /></span>
      </v-toolbar-title>
      <v-spacer />
    
      <v-toolbar-items>
        <v-select
          @change="changedLanguage"
          v-model="selectedLanguage.lang_code"
          :items="languagesdata"
          item-value="lang_code"
          :item-text="'lang_name' | translate"
          :label="'Language' | translate"
          outlined
          dense
          class="pt-3 d-none d-sm-flex"
          style="width:140px;"
        ></v-select>
      </v-toolbar-items>
      <v-btn class="d-none d-sm-flex" icon large>
        <v-icon large @click="contact = true">mdi-telegram</v-icon>
      </v-btn>

      <v-menu
        :close-on-content-click="false"
        offset-y
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large v-on="on">
            <v-icon large>mdi-account</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-content>
              <v-select
                @change="changedLanguage"
                v-model="selectedLanguage.lang_code"
                :items="languagesdata"
                item-value="lang_code"
                item-text="lang_name"
                :label="'Language' | translate"
                dense
                class="d-flex d-sm-none"
              ></v-select>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="d-flex d-sm-none">
            <v-list-item-action>
              <v-icon large>mdi-telegram</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ 'Contact us' | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="d-flex d-sm-none"></v-divider>
          <v-list-item v-for="(item, index) in dropdown" :key="index" @click="action(item.action)">
            <v-list-item-action>
              <v-icon large>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-model="openDrawer"
      permanent
      :mini-variant-width="widthValue"
      :mini-variant.sync="mini"
      :clipped="true"
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
          >
            <template v-slot:activator>
              <v-list-item :style='(mini == false ? "padding: 0px;" : "")'>
                <v-list-item-action>
                  <v-icon large :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item v-for="(child, i) in item.children" :to="child.link" :key="child.text+i" link>
              <v-list-item-action v-if="child.icon ">
                <v-icon :style='(mini == false ? "margin-left: 20px;" : "")' :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text | translate }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" :to="item.link" link>
            <v-list-item-action>
              <v-icon large :color="(Object.keys(currentUser).length !=0 ? JSON.parse(currentUser.company.company_meta).primary_color: '')">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text | translate }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-row justify="center">
      <v-dialog v-model="contact" max-width="500">
        <v-card>
          <v-card-title class="headline">{{ 'Write to Company Representative' | translate }}</v-card-title>
          <v-card-text>
            <v-row v-if="message!== null">
              <v-col cols="12" sm="12">
                <v-alert dense outline type="success">{{ message | translate }}</v-alert>
              </v-col>
            </v-row>
            <v-form ref="contactForm" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="subject"
                    name="subject"
                    :rules="[v => !!v || 'Subject is required']"
                    :label=" 'Subject' | translate"
                    required
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                  
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    outlined
                    name="body"
                    v-model="body"
                    :rules="[v => !!v || 'Body is required']"
                    :label=" 'Body' | translate"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>                   
                  </v-textarea>
                </v-col>
              </v-row>

              <v-checkbox v-model="sendCopy" :label="'Send copy to myself' | translate"></v-checkbox>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary darken-1" text @click="contact = false">{{ 'Close' | translate}}</v-btn>

            <v-btn color="primary darken-1" text @click="contactQuery">{{ 'Submit' | translate }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import {
  LOGOUT,
  FETCH_PAGES,
  STRIPE_RESET_STATE,
  PAGES_RESET_STATE,
  CONTACT_QUERY,
  RESET_STATE,
  FETCH_NAVIGATION_BAR_STATUS,
  GLOBALS_RESET_STATE
} from "@/store/actions.type";
import {
  SET_CUR_LANGUAGE,
  SET_LOADING,
  SET_NAVBAR_WIDTH,
  RESET_ALL_PAGES_DATA,
  SET_LOGGED_IN,
} from "@/store/mutations.type";
import { mapGetters } from "vuex";
export default {
  name: "Navbar",
  props: {
    source: String
  },
  watch: {
    async $route(to) {
      if (to.name === "moduleplayer") {
        window.removeEventListener("resize", this.onResize);
        await store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.onResize();
        window.addEventListener("resize", this.onResize, { passive: true });
      }
    },
    contact(value) {
      if (value) {
        this.message = null;
        this.body = null;
        this.subject = null;
        this.sendCopy = false;
      }
    },
    languages(value){
      if(Object.keys(value).length>0){
        this.setLanguageDropdown();
      }
    },
    pagesdata(){
        this.setDropdown()      
    },
  },
  data: () => ({
    dialog: false,
    drawer: true,
    isMobile: false,
    selectedLanguage: "",
    companylogo: null,
    items: [],
    dropdown: [],
    contact: false,
    sendCopy: false,
    collapseStatus: false,
    subject: "",
    body: "",
    message: null,
    closeOnClick: true,
    closeOnContentClick: false,
    userData: null
  }),
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  created(){
    this.setLanguageDropdown()
    this.setSidebar()
  },
  methods: {
    setLanguageDropdown(){
      this.selectedLanguage =
        this.curLanguage !== null
          ? this.curLanguage
          : this.currentUser.company.language    
      this.selLanguage(this.selectedLanguage)
      Vue.i18n.set(this.curLanguage.lang_code)  
      this.setDropdown()      
      
    },
    setSidebar() {
      this.companylogo = process.env.VUE_APP_STORAGE_URL+this.currentUser.company.company_logo;
      let companymeta = JSON.parse(this.currentUser.company.company_meta);
      if((this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3) || this.currentUser.roles.includes(4) && companymeta.has_inbox == "true" ) || 
      (this.currentUser.is_group_user && companymeta.has_inbox == "true" && !this.currentUser.roles.includes(6))){
        this.items.push({ icon: "mdi-inbox", text: "Inbox", link: "/inbox" })
      }

      if(this.currentUser.roles.includes(5)) {
        this.items.push({ icon: "mdi-test-tube", text: "Drafts", link: "/drafts" })
      }

      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)
        || this.currentUser.roles.includes(4)){
        this.items.push(
            {
            icon: 'mdi-book',
            text: 'Learning',
            model: false,
            children: [
              { icon: "mdi-home", text: "Dashboard", link: "/dashboard" },
              { icon: "mdi-file", text: "Courses", link: "/courses" },
              { icon: "mdi-book", text: "Modules", link: "/modules" },
              { icon: "mdi-file-document", text: "Learning material", link: "/learningmaterial" }
            ],
          }
        )
      }
      else if(this.currentUser.roles.includes(6)){
        this.items.push(
            {
            icon: 'mdi-book',
            text: 'Learning',
            model: false,
            children: [
              { icon: "mdi-home", text: "Dashboard", link: "/dashboard" }
            ],
          }
        )
      }

      

      if(this.currentUser.roles.includes(1)){
        if (companymeta.has_equip_db == "true") {
          this.items.push(
              {
              icon: 'mdi-factory',
              text: 'Equipment',
              model: false,
              children: [
                { icon:'mdi-file-document', text: 'Equipment Template', link: '/equipment-template' },
                { icon:'mdi-format-list-bulleted-square', text: 'Items', link: '/equipment' },
                { icon:'mdi-account-group-outline', text: 'Equipment Group', link: '/equipment-group' },
              ],
            }
          )
        }
        if (companymeta.has_task_center == "true") {
          this.items.push(
              {
              icon: 'mdi-chart-bar',
              text: 'Task Center',
              model: false,
              children: [
                { icon:'mdi-file-outline', text: 'Task Template', link: '/task-center-template' },
                { icon:'mdi-file-document', text: 'Tasks', link: '/task-center' },
                { icon:'mdi-format-list-bulleted-square', text: 'Task Group', link: '/task-center-group' },
              ],
            }
          )
        }


        this.items.push(
            {
            icon: 'mdi-group',
            text: 'User Group',
            model: false,
            children: [
              { icon:'mdi-file-document', text: 'Personal Template', link: '/personal-template' },
              { icon:'mdi-format-list-bulleted-square', text: 'All Groups', link: '/groups' },
            ],
          }
        )
      }
      
      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)){
          this.items.push(
              {
              icon: 'mdi-security',
              text: 'Admin',
              model: false,
              children: [
                { icon: "mdi-account-box", text: "Users", link: "/users" },
              ],
            }
          )
      }

      
      if(this.currentUser.roles.includes(1) && (companymeta.has_external_users == "true")){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-account-outline", text: "External Users", link: "/ext-users" })
      }

      if(this.currentUser.roles.includes(1)){
        this.items[this.items.findIndex(o=>o.text == 'Admin')]['children'].push({ icon: "mdi-cog", text: "Settings", link: "/Settings" },{ icon: "mdi-email", text: "Reminder", link: "/reminder" })
      }

      if (this.currentUser.company.account_type == "on-demand") {
        if(this.currentUser.roles.includes(1)){
          this.items.push(
              {
              icon: 'mdi-wallet-giftcard',
              text: 'Vouchers',
              model: false,
              children: [
                { icon: "mdi-wallet-membership", text: "Buy Course Vouchers", link: "/vouchers" },
                { icon: "mdi-clipboard-check", text: "Manage Course Vouchers", link: "/coupons" },
                { icon: "mdi-ticket", text: "Buy Tutor Vouchers", link: "/tutor-vouchers" },
                { icon: "mdi-ticket-account", text: "Manage Tutor Vouchers", link: "/tutor-coupons" }
              ],
            }
          )
        }
      }
      

    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async contactQuery() {
      if (this.$refs.contactForm.validate()) {
        this.$store
          .dispatch(CONTACT_QUERY, {
            subject: this.subject,
            body: this.body,
            send_copy: this.sendCopy
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.message = "Query successfully sent";
              this.$store.commit(SET_LOADING, false);
            }
            else{
              this.$store.commit(SET_LOADING, false);
            }
          });
      }
    },
    setDropdown() {
      let pages = this.pagesdata.filter(o => o.page_slug !== 'legalnotice').map(function(obj) {
          return {
            icon: obj.icon_code,
            text: obj.page_title,
            action: obj.page_slug
          };
      });

      if (this.currentUser.company.account_type == "on-demand") {
        this.dropdown = [
          { icon: "mdi-account-box", text: "Profile", action: "profile" },
          { icon: "mdi-calculator", text: "Invoices", action: "invoices" },
        ];
      } else {
        this.dropdown = [
          { icon: "mdi-account-box", text: "Profile", action: "profile" }
        ];
      }

      pages.forEach(item => this.dropdown.push(item));

      this.dropdown.push({
        icon: "mdi-power",
        text: "Logout",
        action: "logout"
      });
    },
    fetchPages() {
      this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown()    
            this.$store.commit(SET_LOADING, false)
          }
        });
    },
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value === x.lang_code);
      await this.$store.commit(SET_CUR_LANGUAGE, selectedLanguage);
      await store.dispatch(PAGES_RESET_STATE);
      await this.$store
        .dispatch(FETCH_PAGES, "?lang_ids=" + this.curLanguage.lang_id)
        .then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.setDropdown();
            this.$store.commit(SET_LOADING, false)
          }
        });
    },
    onResize() {
      this.isMobile = window.innerWidth < 600;
      if (this.isMobile) {
        this.collapseStatus = true;
        store.commit(SET_NAVBAR_WIDTH, 0);
      } else {
        this.collapseStatus = false;
        store.commit(SET_NAVBAR_WIDTH, 80);
      }
    },
    async action(status) {
      switch (status) {
        case "profile":
          this.$router.push("/profile");
          break;
        case "invoices":
          this.$router.push("/invoices");
          break;
        case "logout":
          Promise.all([   
            await this.$store.dispatch(STRIPE_RESET_STATE),
            await  this.$store.commit(RESET_ALL_PAGES_DATA),
            await this.$store.dispatch(PAGES_RESET_STATE),
            await this.$store.dispatch(RESET_STATE),
            await this.$store.dispatch(GLOBALS_RESET_STATE), 
            await this.$store.dispatch(LOGOUT),
            await this.$store.commit(SET_LOGGED_IN, false),          
          ]).finally(() => { 
            this.$router.push("/login");
          });
          break;
        default:
          this.$router.push("/pages/" + status);
      }
    },
    status: function() {
      this.$store.dispatch(FETCH_NAVIGATION_BAR_STATUS);
    }
  },
  computed: {
    ...mapGetters([
      "mini",
      "languages",
      "currentUser",
      "widthValue",
      "pagesdata",
      'curLanguage'
    ]),
    openDrawer: {
      get: function () {
        return this.mini
      },
      set: function () {
        //this.$store.dispatch(FETCH_NAVIGATION_BAR_STATUS)
      }
 
    },
    languageLabel(){
      return this.$t('Language')
    },
    languagesdata(){
      return this.languages.map(data =>{
        return{
         'lang_code': data.lang_code,
         'lang_id':  data.lang_id,
         'lang_name': this.$t(data.lang_name),
        }
     
      })
    },
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    }
  }
};
</script>